module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-06-c6eb7a8b2f8cb4e83f241e2a28037389.jpg";